/// <amd-module name="VSSUI/Registration/PivotBarRegistration" />
import { VssComponent } from "VSS/Platform/Layout";
import { PivotBar } from "../PivotBar";

VssComponent.register("pivotBar", PivotBar);
